<template>
  <div class="detail">
    <common-head title="门诊详情" />
    <div class="top-notice">
      <div class="my-card my-tags">
        <div class="row-top">{{ office.name }}</div>
        <div class="row-mid">
          <van-tag
            v-for="(item, index) in office.types"
            :key="index"
            plain
            type="primary"
          >
            {{ item }}
          </van-tag>
          <van-tag plain type="primary" v-if="office.isTwentyFourHours">24H</van-tag>
        </div>
        <div class="row-btm">
          <div class="left van-ellipsis">
            <img src="@/assets/imgs/map.png">
            <span>{{ office.registerAddress }}</span>
          </div>
          <div class="right">{{ office.distance }}km</div>
        </div>
      </div>
    </div>
    <div class="my-wrap">
      <div class="my-card intro">
        <b>门诊简介</b>
        <div class="my-html" v-html="office.introduce" v-if="office.introduce"></div>
        <div class="my-empty" v-else>暂无内容</div>
      </div>
      <!-- <div class="my-card comment">
        <div class="header">
          <b>服务评价</b>
          <div class="right">
            <span>查看更多</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in 3" :key="index">
            <van-rate :value="3" color="#FAD837" />
            <p>医生很有耐心</p>
            <div class="info">
              <span class="left">王先生 门诊挂号</span>
              <span class="right">2022-03-02</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="my-button">
      <van-button type="info" round @click="confirm">立即预约疫苗</van-button>
    </div> -->
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import { mapState } from 'vuex'

export default {
  components: {
    CommonHead
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapState(['office'])
  },
  methods: {
    confirm() {
      this.$store.commit('setOfficeCopy', this.$store.state.office)
      this.$store.commit('setVacc', null)
      this.$router.push('/appointment')
    }
  }
}
</script>

<style lang="less" scoped>
.detail {
  // padding-bottom: 74px;
  .top-notice {
    height: 123px;
    background: url(../../assets/imgs/top-notice.jpg) no-repeat center/100% 100%;
    display: flex;
    align-items: center;
    transform: translateY(-0.3px);
    padding: 0 13px;
    .my-tags {
      width: 100%;
    }
  }
  .my-wrap {
    b {
      opacity: .9;
    }
    .intro {
      margin-bottom: 13px;
      .my-html {
        margin-top: 11px;
      }
    }
    .comment {
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .right {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #757575;
          opacity: .9;
          span {
            margin-right: 6px;
          }
        }
      }
      .list {
        .item {
          opacity: .9;
          padding: 19px 0;
          border-bottom: 1px solid #eee;
          &:last-child {
            border-bottom: 0;
          }
          p {
            font-size: 13px;
            margin: 5px 0;
          }
          .info {
            font-size: 11px;
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #a9a9a9;
          }
        }
      }
    }
  }
}
</style>